import React from "react";
import _ from "lodash";
import { Grid, Button } from "semantic-ui-react";
import { singleSlider } from "schema/TemplateSchema.react";
import VideoBox from "globals/videobox/VideoBox.react";
import Question from "slides/components/Question.react";

export default class GridLandscape extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onlyImage: false,
        };
    }
    toggleImage = () => this.setState({ onlyImage: !this.state.onlyImage });
    render() {
        let isIframe = window.location !== window.parent.location;

        let hasBackground =
            (this.props.data.image &&
                this.props.data.image.indexOf("default") === -1) ||
            (this.props.background &&
                this.props.background.indexOf("default") === -1);
        let backgroundImage = hasBackground
            ? _.find(this.props.deck.images, {
                  id: this.props.data.image
                      ? this.props.data.image
                      : this.props.background,
              })
            : null;
        let pageWrapperStyle = {
            minHeight: "100%",
            backgroundImage: `url(${
                backgroundImage ? backgroundImage.image : ""
            })`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            position: "relative",
        };
        let leftSectionStyle = {
            position: "relative",
            width: "100%",
            height: "100%",
            color: this.props.colors.baseText,
            display: this.state.onlyImage ? "none" : "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
        };
        let rightSectionStyle = {
            height: "100%",
            textAlign: "center",
        };
        let questionStyle = {
            fontSize: "1.25em",
        };
        let mainSectionStyle = {
            width: "100%",
            fontSize: "1.25em",
            display: this.state.onlyImage ? "none" : "block",
        };
        let overlay = {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.35)",
            display:
                !backgroundImage || this.state.onlyImage ? "none" : "block",
        };
        let videoBox = {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
        };

        return (
            <Grid centered style={pageWrapperStyle} columns={1}>
                <div style={videoBox}>
                    {this.props.data.video != null && (
                        <VideoBox url={this.props.data.video} autoplay={true} />
                    )}
                </div>
                <div style={overlay} />
                <Grid.Row>
                    <Grid.Column width={8}>
                        <div style={leftSectionStyle}>
                            <div className="full-width">
                                <div style={questionStyle}>
                                    <Question {...this.props} />
                                </div>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={12}>
                        <div style={rightSectionStyle}>
                            <div style={mainSectionStyle}>
                                {this.props.mainContent}
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                {hasBackground && !isIframe && (
                    <Button
                        secondary
                        size="tiny"
                        content={
                            this.state.onlyImage
                                ? "Show Content"
                                : "Hide Content"
                        }
                        style={{
                            position: "absolute",
                            bottom:
                                singleSlider.indexOf(
                                    this.props.deck.readerType
                                ) === -1
                                    ? "35px"
                                    : "0px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: "9",
                            borderRadius: "5px 5px 0 0",
                        }}
                        onClick={this.toggleImage}
                    />
                )}
            </Grid>
        );
    }
}
